/** @jsx jsx */
import { jsx } from '@emotion/core'
import styled from '@emotion/styled'
import React, { useState, useContext, useMemo, useEffect } from 'react'

import {
  unitIdHeader,
  modifierCol,
  modifiedDateCol,
} from 'core/HeaderColTypeProps'
import { dateCol, strCol, numCol } from '@integec/grid-tools/lib/cols'
import {
  retrieveConstraints,
  deleteConstraints,
  saveConstraints,
  // retrieveOaConstraintsPFuelCodes,
} from 'api/pgads'
import { connect } from 'react-redux'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnits,
  hasAccesPermits,
} from 'core'
import { CriteriaRow } from 'core/screen-util'
import { Button, DatePicker, InputNumber, Select, Switch } from 'antd'
import { ErrorContext, PNodeZoneContext } from 'context'
import * as Actions from 'core/EventActions'

import CommonScreen from 'admin/component/CommonScreen'

import { toSelectionColProps } from '@integec/grid-tools'

import MarginAnalysisUtilityUnitSelection from './../MarginAnalysisUtilityUnitSelection'
import {
  // getPFuelCodeAtFuelUsageByClients,
  getPFuelCodeForConstraintsByClients,
} from 'marginanalysis/utils'
import { DatePickerContext } from '../../context/DatePickerContext'

const title = 'Constraints'

const Label = styled.div`
  display: grid;
  justify-content: end;
  align-content: center;
`

const headers = [
  //   strCol({ ident: 'unitid', display: 'Unitid', isKey: true, sortOrder: 'asc' }),
  unitIdHeader,
  dateCol({
    ident: 'effectivedate',
    display: 'Effective Date',
    isKey: true,
    sortOrder: 'desc',
    width: 150,
  }),
  strCol({
    ident: 'pFuelCode',
    display: 'PFuel Code',
    isKey: true,
    sortOrder: 'asc',
    width: 300,
    ellipsis: true,
    // ...toSelectionColProps(seasonChioce),
  }),
  numCol({
    ident: 'ecoMinMw',
    display: 'Eco Min Mw',
    isFiltered: true,
    displayFormat: '0.0',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'ecoMaxMw',
    display: 'Eco Max Mw',
    isFiltered: true,
    displayFormat: '0.0',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'emerMinMw',
    display: 'Emer Min Mw',
    isFiltered: true,
    displayFormat: '0.0',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'emerMaxMw',
    display: 'Emer Max Mw',
    isFiltered: true,
    displayFormat: '0.0',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'noLoadCost',
    display: 'No Load Cost',
    isFiltered: true,
    // displayFormat: '0.00000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'minRunTime',
    display: 'Min Run Time',
    isFiltered: true,
    // displayFormat: '0.00000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'maxRunTime',
    display: 'Max Run Time',
    isFiltered: true,
    // displayFormat: '0.00000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'minDownTime',
    display: 'Min Down Time',
    isFiltered: true,
    // displayFormat: '0.00000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'hotToColdTime',
    display: 'Hot to Cold Time',
    isFiltered: true,
    // displayFormat: '0.00000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'hotToInterTime',
    display: 'Hot to Inter Time',
    isFiltered: true,
    // displayFormat: '0.00000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'coldStartupTime',
    display: 'Cold Startup Time',
    isFiltered: true,
    // displayFormat: '0.00000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'interStartupTime',
    display: 'Inter Startup Time',
    isFiltered: true,
    // displayFormat: '0.00000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'hotStartupTime',
    display: 'Hot Startup Time',
    isFiltered: true,
    // displayFormat: '0.00000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'maxDailyStarts',
    display: 'Max Daily Starts',
    isFiltered: true,
    // displayFormat: '0.00000',
    sortOrder: 'asc',
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]

// eslint-disable-next-line no-unused-vars
const Constraints = ({ targetInfo, envConfig, actionPermits, ...props }) => {
  // const { selectedUnits } = useContext(UnitSelectionContext)
  const { setError } = useContext(ErrorContext)
  const [insertEvent, setInsertEvent] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [editMode, setEditMode] = useState(true)

  const [pFuelCodeMap, setPFuelCodeMap] = useState({})
  const {
    selectedDate,
    setSelectedDate,
    selectedDateRangePicker,
    setSelectedDateRagePicker,
  } = useContext(DatePickerContext)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <CriteriaRow>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            '120px 100px 130px 150px 110px 150px 120px 180px 120px 150px',
          gridGap: '5px',
        }}
      >
        <Label>Unit:</Label>
        <div style={{ gridColumn: 'span 3' }}>
          <MarginAnalysisUtilityUnitSelection
            utility={insertData.utility || null}
            unit={insertData.unit || null}
            onUnitChange={value => {
              // setUtilityUnit(value)
              setInsertData({
                ...insertData,
                utility: value[0],
                unit: value[1],
                unitId: unitIdEmktIdMap[value[1]],
              })
            }}
            style={{ width: '100%' }}
            showX2X3
          />
        </div>
        <Label>Effective Date:</Label>
        <DatePicker
          allowClear={false}
          format="MM/DD/YYYY"
          value={insertData.effectivedateObj}
          onChange={date => {
            setInsertData({
              ...insertData,
              effectivedate: date.format('YYYY-MM-DD'),
              effectivedateObj: date,
            })
          }}
          style={{ width: '100%' }}
        />
        <Label>PFuel Code:</Label>
        <Select
          value={insertData.pFuelCode}
          onChange={value => setInsertData({ ...insertData, pFuelCode: value })}
          style={{ width: '100%' }}
        >
          {Object.keys(pFuelCodeMap).map(m => (
            <Select.Option key={m} value={m}>
              {m === pFuelCodeMap[m] ? m : m + ' - ' + pFuelCodeMap[m]}
            </Select.Option>
          ))}
        </Select>
        <div />
        <div />
        <Label>Eco Min Mw:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.ecoMinMw}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, ecoMinMw: value })}
        />
        <Label>Eco Max Mw:</Label>
        <InputNumber
          style={{ width: '100%' }}
          defaultValue={0}
          value={insertData.ecoMaxMw}
          onChange={value => setInsertData({ ...insertData, ecoMaxMw: value })}
        />
        <Label>Emer Min Mw:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.emerMinMw}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, emerMinMw: value })}
        />
        <Label>Emer Max Mw:</Label>
        <InputNumber
          style={{ width: '100%' }}
          defaultValue={0}
          value={insertData.emerMaxMw}
          onChange={value => setInsertData({ ...insertData, emerMaxMw: value })}
        />
        <Label>No Load Cost:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.noLoadCost}
          defaultValue={0}
          onChange={value =>
            setInsertData({ ...insertData, noLoadCost: value })
          }
        />
        <Label>Min Run Time:</Label>
        <InputNumber
          style={{ width: '100%' }}
          defaultValue={0}
          value={insertData.minRunTime}
          onChange={value =>
            setInsertData({ ...insertData, minRunTime: value })
          }
        />
        <Label>Max Run Time:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.maxRunTime}
          defaultValue={0}
          onChange={value =>
            setInsertData({ ...insertData, maxRunTime: value })
          }
        />
        <Label>Min Down Time:</Label>
        <InputNumber
          style={{ width: '100%' }}
          defaultValue={0}
          value={insertData.minDownTime}
          onChange={value =>
            setInsertData({ ...insertData, minDownTime: value })
          }
        />
        <Label>Hot to Cold Time:</Label>
        <InputNumber
          style={{ width: '100%' }}
          defaultValue={0}
          value={insertData.hotToColdTime}
          onChange={value =>
            setInsertData({ ...insertData, hotToColdTime: value })
          }
        />
        <Label>Hot to Inter Time:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hotToInterTime}
          defaultValue={0}
          onChange={value =>
            setInsertData({ ...insertData, hotToInterTime: value })
          }
        />
        <Label>Cold Startup Time:</Label>
        <InputNumber
          style={{ width: '100%' }}
          defaultValue={0}
          value={insertData.coldStartupTime}
          onChange={value =>
            setInsertData({ ...insertData, coldStartupTime: value })
          }
        />
        <Label>Inter Startup Time:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.interStartupTime}
          defaultValue={0}
          onChange={value =>
            setInsertData({ ...insertData, interStartupTime: value })
          }
        />
        <Label>Hot Startup Time:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hotStartupTime}
          defaultValue={0}
          onChange={value =>
            setInsertData({ ...insertData, hotStartupTime: value })
          }
        />
        <Label>Max Daily Starts:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.maxDailyStarts}
          defaultValue={0}
          onChange={value =>
            setInsertData({ ...insertData, maxDailyStarts: value })
          }
        />
        <div
          style={{
            gridColumn: 'span 2',
            gridRowGap: '10px',
            width: '100%',
            display: 'grid',
            gridTemplateColumns: 'auto auto auto',
            paddingLeft: '5px',
            gridColumnGap: '10px',
          }}
        >
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>
          <Button type="primary" onClick={() => onAdd(false)}>
            Add & Hide
          </Button>
          <Button type="danger" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    </CriteriaRow>
  )

  useEffect(
    _ => {
      getPFuelCodeForConstraintsByClients({
        targetInfo,
        setError,
        setPFuelCodeMap,
        CLIENT: envConfig.clientId,
      })
    },
    [envConfig.clientId, setError, targetInfo]
  )

  const { unitIdEmktIdMap, emktIdUnitNameMap, marginUnitsList } = useContext(
    PNodeZoneContext
  )

  const headerWithFormatter = headers.map(header =>
    header.ident === 'unitId' || header.ident === 'unitid'
      ? {
          ...header,
          dataFormatter: ({ value }) => emktIdUnitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            emktIdUnitNameMap[rowData.unitId] ||
            emktIdUnitNameMap[rowData.unitid] ||
            rowData.unitId ||
            rowData.unitid,
        }
      : header.ident === 'pFuelCode'
      ? {
          ...header,
          ...toSelectionColProps(pFuelCodeMap),
          dataFormatter: ({ value }) => value + ' - ' + pFuelCodeMap[value],
        }
      : header
  )

  const writeEventActionPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          Actions.MARGIN_ANALYSIS_ADMIN,
          Actions.MARGIN_ANALYSIS_CORE_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const writePermission = useMemo(_ => writeEventActionPermission && editMode, [
    writeEventActionPermission,
    editMode,
  ])
  const [byEff, setByEff] = useState(false)

  const withCriteria = (state, props, selectedUnits, selectedDate) => {
    return {
      startDate: selectedDateRangePicker[0],
      endDate: selectedDateRangePicker[1],
      units: (selectedUnits || [])
        .filter(e => !!e)
        .map(e => unitIdEmktIdMap[e.unitId]),
      effectieveDate: selectedDate,
      byEff,
    }
  }

  const screenCriteria = (s, p, u, onChange) => {
    return (
      <div>
        <Switch
          onClick={checked => {
            setByEff(checked)
            onChange()
          }}
          checked={byEff}
          checkedChildren="Effective Date"
          unCheckedChildren="Date Range"
        />
        {byEff && (
          <DatePicker
            allowClear={false}
            format="MM/DD/YYYY"
            value={selectedDate}
            onChange={d => {
              setSelectedDate(d)
              onChange()
            }}
            style={{ marginLeft: '5px' }}
          />
        )}

        {!byEff && (
          <DatePicker.RangePicker
            style={{ marginLeft: '15px' }}
            allowClear={false}
            format="MM/DD/YYYY"
            value={selectedDateRangePicker}
            onChange={d => {
              setSelectedDateRagePicker(d)
              onChange()
            }}
          />
        )}
      </div>
    )
  }

  const extraUnitSelectionProps = _ => ({
    limitedUnits: marginUnitsList,
    units: marginUnitsList,
    // itemToLabel: e => e.emktId,
  })

  // eslint-disable-next-line no-unused-vars
  const isEditableGrid = ({ header, rowData }) => {
    if (
      header.ident === 'modifier' ||
      header.ident === 'modifiedDate' ||
      header.isKey
    )
      return false

    return writePermission
  }

  return (
    <div>
      <CommonScreen
        // modifySaveDataBeforeSave={modifySaveDataBeforeSave}
        // withDatePicker={byEff}
        // withDatePickerTitle={byEff ? 'Effective Date :' : 'Date Range :'}
        withoutModify={!writeEventActionPermission}
        withDelete={!writeEventActionPermission}
        allowInsert={writeEventActionPermission}
        isEditableGrid={isEditableGrid}
        extraUnitSelectionProps={extraUnitSelectionProps}
        withUnitSelection
        autoRetrieve={false}
        isAdminScreen={false}
        withCriteria={withCriteria}
        screenCriteria={screenCriteria}
        title={title}
        header={headerWithFormatter}
        saveTask={saveConstraints}
        retrieveTask={retrieveConstraints}
        deleteTask={deleteConstraints}
        altBy={u => u.unitId}
        sortOptions={headers}
        initialSortOptions={headers}
        widthOffset={50}
        insertComp={insertEvent && insertComp}
        insertCompHeight={220}
        onInsertEvent={b => setInsertEvent(b)}
        withImport
        importUrl="marginanalysisdata-import/generic-import"
        importData={{ importType: 'MA_CONSTRAINTS' }}
      />
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  units: getUnits(state),
})

export default connect(mapStateToProps)(Constraints)
